import src from "IMAGE";
export default { src, width: 733, height: 791, blurWidth: 0, blurHeight: 0};
